import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SaveAsDraft from './saveAsDraft';
import {
  getPocList,
  createMeeting,
  getMeetingById,
  updateMeeting,
  getInvoiceList,
  saveDraftMeeting,
  getSaveAsDraftData,
  discardDraftMeeting
} from 'services/redux/brandActivtion/meetings/action';
import { getCorpPocList } from 'services/redux/brandActivtion/corporateClient/action';
import { getCorpClientList, getBaOpportunityFromLeadx } from 'services/redux/brandActivtion/corporateClient/action';
import { documentUploadUrl } from "services/redux/fileUpload/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
import {getSiteFilters} from "../../../../services/redux/brandActivtion/siteMaintenance/action";

const mapStateToProps = (state) => ({
  pocList: state.baMeetingReducer.pocList,
  meetingById: state.baMeetingReducer.meetingById,
  corpClientList: state.CorpClientReducer.corpClientList,
  opportunityList: state.CorpClientReducer.opportunityList,
  corpClientPoc: state.CorpClientReducer.corpClientPoc,
  invoiceList: state.baMeetingReducer.invoiceList,
  getDraftEditData: state.baMeetingReducer.getDraftEditData,
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
  siteFilters: state.baSiteListingReducer.siteFiltersData,

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPocList,
      createMeeting,
      getMeetingById,
      updateMeeting,
      getCorpClientList,
      documentUploadUrl,
      getCorpPocList,
      getInvoiceList,
      documentUploadUrlPublic,
      getBaOpportunityFromLeadx,
      saveDraftMeeting,
      getSaveAsDraftData,
      discardDraftMeeting,
      getSiteFilters
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SaveAsDraft);
